/**
 * Umami tracker loader.
 *
 * Dormant until `VITE_UMAMI_WEBSITE_ID` is set at build time: the website id only exists
 * after umami is reachable and a site has been created in its dashboard, so the bundle ships
 * ready but inert and one env var turns it on. Cookieless — no consent banner needed
 * (docs/runbooks/analytics-queries.md). The script origin is also named in the CSP
 * (infra/Caddyfile); changing `VITE_UMAMI_SRC` without the matching CSP entry will be blocked
 * by the browser.
 *
 * A crawler that does not execute this module never fires the beacon — that is the whole
 * point: the visitor count is a real-human floor, not the server's every-request total.
 */
const WEBSITE_ID = import.meta.env['VITE_UMAMI_WEBSITE_ID'] as string | undefined;
const SRC = import.meta.env['VITE_UMAMI_SRC'] as string | undefined;

export function installAnalytics(): void {
  if (WEBSITE_ID === undefined || WEBSITE_ID === '' || SRC === undefined || SRC === '') return;

  const script = document.createElement('script');
  script.defer = true;
  script.src = SRC;
  script.dataset['websiteId'] = WEBSITE_ID;
  document.head.appendChild(script);
}
